<h2 mat-dialog-title>Session Expiring</h2>

<mat-dialog-content>
  <div class="session-content">
    <p>Your session will expire in <strong>{{ countdown | sbTimeFormat }}</strong></p>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onStayLoggedIn()">Stay Logged In</button>
</mat-dialog-actions>
